module.exports = __webpack_public_path__ + "img/sensitivity-icon-4.5409efa6.svg";